import * as React from 'react';

const VesisLightIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={50} viewBox="0 0 58 50" width={58} xmlns="http://www.w3.org/2000/svg" {...props}>
        <mask
            height={50}
            id="mask0_209_1778"
            maskUnits="userSpaceOnUse"
            style={{
                maskType: 'luminance',
            }}
            width={58}
            x={0}
            y={0}
        >
            <path d="M57.5342 0H0V50H57.5342V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_209_1778)">
            <path
                d="M27.1516 17.8296C33.3253 7.17996 44.6386 0.555498 56.9371 0.347412L28.5572 
                49.3169L18.7303 32.3613L27.1516 17.8296Z"
                fill="white"
            />
            <path d="M26.947 11.4798L11.6436 5.02691L10.6036 0H20.2923L26.947 11.4798Z" fill="white" />
            <path
                d="M27.0221 11.6101L16.9441 29.0018L16.424 28.1057L11.6437 5.02686L26.947 11.4797L27.0221 11.6101Z"
                fill="#CDD0D3"
            />
            <path d="M16.424 28.1057L0.269775 0.230225L11.6437 5.02687L16.424 28.1057Z" fill="#7A818B" />
            <path d="M11.6437 5.02691L0.269775 0.230262L0.136292 0H10.6036L11.6437 5.02691Z" fill="#CCCCCC" />
        </g>
    </svg>
);
export default VesisLightIcon;
